export default __webpack_public_path__ + "static/media/banner-3.078ff343.jpg";